module.exports = __webpack_public_path__ + "img/LSAT40.94b109ed.png";